<template>
  <form
    @submit.prevent="signUp"
    class="login-form form rounded border border-warning">
    <h3>Create a New Account</h3>
    <div class="form-group">
      <label>Email Address</label>
      <input
        class="form-control"
        type="email"
        placeholder="Email"
        v-model="email"
        required
      />
    </div>
    <div class="form-group">
      <label>Name</label>
      <input
        class="form-control"
        type="text"
        placeholder="Name"
        v-model="displayName"
        required
      />
    </div>
    <div class="form-group">
      <label>Password</label>
      <input
        class="form-control"
        type="password"
        placeholder="Pasword"
        v-model="password"
        required
      />
    </div>
    <button class="btn btn-warning btn-block">Sign Up</button>
    <p class="small">Return to <router-link to="/login">Login</router-link></p>
    <p class="alert alert-danger" v-if="errorMessage">{{ errorMessage }}</p>
  </form>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'Signup',
  data() {
    return {
      email: '',
      password: '',
      errorMessage: '',
      displayName: '',
      codeWord: ''
    };
  },
  methods: {
    signUp() {
      firebase.auth().createUserWithEmailAndPassword(this.email, this.password).then((user) => {
        user = firebase.auth().currentUser;
        user.updateProfile({
          displayName: this.displayName
        }).then(() => {
          this.$router.replace('home');
        }, (error) => {
          this.errorMessage = error.message;
        });
      },
      (err) => {
        this.errorMessage = err.message;
      }
      );
    }
  }
};
</script>
